export { default as DataTablePagination } from './DataTablePagination';
